const getSearchResultItemUrl = (item) => (item.link
  ? `/${ item.link.pathname }?${ item.link.search }`
  : `/${ item.url }`
);

export default getSearchResultItemUrl;
